import { memo, useCallback } from 'react';
import { Pressable } from 'react-native';
import { RadioButtonProps } from './Radio.types';
import Box from '../Box/Box';
import Text from '../Text/Text';

function RadioButton({
  locKey,
  locNS,
  label,
  value,
  onValue,
  selected,
}: RadioButtonProps) {
  const onPress = useCallback(() => onValue(value), [value, onValue]);

  return (
    <Pressable onPress={onPress}>
      <Box flexDirection="row" alignItems="center" gap="space-200">
        {selected ? (
          <Box
            variant="gradient"
            gradient="accentBackground"
            width="space-500"
            height="space-500"
            borderRadius="radius-full"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              backgroundColor="primaryBackground"
              width={10}
              height={10}
              borderRadius="radius-full"
            />
          </Box>
        ) : (
          <Box
            backgroundColor="whiteBackground"
            width="space-500"
            height="space-500"
            borderRadius="radius-full"
            justifyContent="center"
            alignItems="center"
          >
            <Box
              backgroundColor="primaryBackground"
              width="space-400"
              height="space-400"
              borderRadius="radius-full"
            />
          </Box>
        )}
        <Box flex={1}>
          <Text
            variant="body-m"
            color="darkSurfacePrimary"
            locKey={locKey}
            locNS={locNS}
            width="100%"
          >
            {label}
          </Text>
        </Box>
      </Box>
    </Pressable>
  );
}

export default memo(RadioButton);
